// Translations
import landing from '../views/landing/translations/de'

// Translation: Password change (German)
export default Object.freeze({
	name: '',
	views: { landing }
})
